import './advantages';
import './advantages.scss';
import './img/advantages.png';

$('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");
$(document).on('closed', '.remodal', function (e) { // eslint-disable-line
  $('.youtube-iframe').each(function() {
    $(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

});


// WEBPACK FOOTER //
// ./resources/views/partials/home/advantages/advantages.js